import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TextButton, LoadingButton } from 'kubra-ux-forge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/pro-solid-svg-icons';
import IamApi from 'api/IamApi';
import { USER_LOGOUT } from 'actions/userActions';
import routing from 'routing';
import exclamationMark from "assets/Exclamation-mark.svg";
import {ITEM_VOIDED_ARCHIVED_NAMESPACE, BALANCE_NAMESPACE, PAYABLE_REVIEW_NAMESPACE } from 'constants/i18n-namespaces';
import usePaymentHistory from 'hooks/usePaymentHistory';
import { getBiller } from 'selectors';
import { MAX_RECENT_PAYMENTS } from '../../secure/common/payable-recent-payments';

export const ItemVoidedArchived = (): JSX.Element => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation([ITEM_VOIDED_ARCHIVED_NAMESPACE,PAYABLE_REVIEW_NAMESPACE, BALANCE_NAMESPACE]);
  const [loading, setLoading] = useState(false);
  const [paymentsLoading, setPaymentsLoading] = useState(false);
  
  const finalBiller = useSelector(getBiller);
  const {    
    loadRecentPayments,
    getRecentPayments,
  } = usePaymentHistory(true);
  const recentPayments = getRecentPayments();  
  
  useEffect(() => {
    // Load recent payments 
    const loadRecentPaymentsData = async () => {
      if (finalBiller) {
        try {
          setPaymentsLoading(true);
          await loadRecentPayments(
            MAX_RECENT_PAYMENTS,
            finalBiller.clientId,
            finalBiller.realm
          );
        } catch (error) {
          console.error("Error loading recent payments:", error);
        } finally {
          setPaymentsLoading(false);
        }
      }
    };

    loadRecentPaymentsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [finalBiller]);
  
  const handlePayDifferentItem = async () => {
    setLoading(true);
    try {
      await IamApi.ezpay.logout();
      dispatch({ type: USER_LOGOUT });
      navigate(routing.index());
    } catch (error) {
      console.error('Error during logout:', error);
      setLoading(false);
    }
  };

  return (
      <div className="item-voided-archived-frame">
          <div className="item-voided-archived-inner-frame">
              <div className="item-voided-archived-image" >
                  <img
                      data-cy="image-item-voided-archived"
                      data-testid="item-voided-archived-image"
                      src={exclamationMark}
                      alt="item voided or archived"
                  />
              </div>
              <div className="item-voided-archived-message">
                  <h2 data-cy="heading-item-voided-or-archived">{t("item-voided-archived", { ns: ITEM_VOIDED_ARCHIVED_NAMESPACE })}</h2>
                  <div className="item-voided-archived-info" data-cy="description-item-voided-archived">
                    {t("item-voided-archived-description", { ns: ITEM_VOIDED_ARCHIVED_NAMESPACE })}
                   </div>
                  
              </div>
              <div className='item-voided-archived-buttons-container'>
                {!paymentsLoading && recentPayments.length > 0 && (
                      <div>
                          <TextButton type="button" data-cy="button-view-recent-payments"
                           onClick={() =>
                              navigate(routing.payableRecentPayments.index(), { 
                                state: { from: 'item-voided-archived' } 
                              })
                          }>
                              {t("view-recent-payment", { ns: BALANCE_NAMESPACE })}
                          </TextButton>
                      </div>
                  )}
                  <div>
                      <LoadingButton
                        loadingState="text"
                        onClick={handlePayDifferentItem}
                        className="pay-different-item-button"
                        data-cy="button-pay-different-item"
                        disabled={loading}
                      >
                        {loading && (
                          <div className="button-icon">
                            <FontAwesomeIcon icon={faCircleNotch} className="fa-spin" />
                          </div>
                        )}
                        {!loading && (
                          <div>{t("pay-different-item", { ns: PAYABLE_REVIEW_NAMESPACE })}</div>
                        )}
                      </LoadingButton>
                  </div>                  
              </div>
          </div>
      </div>
  );
};

export default ItemVoidedArchived;